module.exports = {"632224100":"沙柳河镇","632224101":"哈尔盖镇","632224200":"伊克乌兰乡","632224201":"泉吉乡","632224202":"吉尔孟乡","632224400":"青海湖农场","632224401":"三角城种羊场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632224.json
// module id = 2782
// module chunks = 0